import { render, staticRenderFns } from "./ChildUserList.vue?vue&type=template&id=cfade890&scoped=true&"
import script from "./ChildUserList.vue?vue&type=script&lang=js&"
export * from "./ChildUserList.vue?vue&type=script&lang=js&"
import style0 from "./ChildUserList.vue?vue&type=style&index=0&id=cfade890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfade890",
  null
  
)

export default component.exports